import { ICampaigns } from 'redux/slices/Campaigns/Campaigns.interface';
import { Igroup } from 'redux/slices/GroupAmbassador/GroupAmbassador.interface';
import { InfoUser } from 'redux/slices/userSlice';
import { Points, SocialNetworkCampaign } from 'types/appTypes';

export const networkCampaign = (
  campaign: ICampaigns,
  contentType: string,
  content: string,
  picturesUrls: Array<string> = [],
  videoFileUrl: string,
  pdfUrl: string,
  urnLi: string,
  url: string,
  provider: string,
  points: Points,
  totalPoints: number,
  detailPoints: Points,
  infoUser: InfoUser,
  linked: boolean,
  invalidToken: boolean,
  status: string,
  networkFlagParticipation: boolean,
  uid: string,
  content2?: string,
  content3?: string,
  isInstagramBusiness?: boolean
): SocialNetworkCampaign => {
  return {
    contentType: contentType,
    content: content,
    content2: content2,
    content3: content3,
    picturesUrls: picturesUrls,
    videoFileUrl: videoFileUrl,
    pdfUrl: pdfUrl,
    urnLi: urnLi,
    url: url,
    provider: provider,
    points: points,
    userPosts: provider === 'facebook' ? campaign.userPosts : [],
    infoUser: infoUser,
    employeePost: {
      id: 1,
      actableType: '',
      status: status,
      content: content,
      totalPoints: totalPoints,
      detailPoints: detailPoints,
      networkFlagParticipation: networkFlagParticipation,
      realPostUrl: uid,
      socialNetworkAccount: {
        id: 1,
        linked: linked,
        invalidToken: invalidToken || false,
        provider: provider
      }
    },
    isInstagramBusiness: isInstagramBusiness
  };
};

export const networkCampaignNull = (): SocialNetworkCampaign => {
  return {
    contentType: '',
    content: '',
    picturesUrls: [],
    videoFileUrl: '',
    pdfUrl: '',
    urnLi: '',
    url: '',
    provider: '',
    points: {} as Points,
    infoUser: {} as InfoUser,
    employeePost: {
      id: 1,
      actableType: '',
      status: '',
      content: '',
      totalPoints: 0,
      detailPoints: {} as Points,
      networkFlagParticipation: false,
      realPostUrl: '',
      socialNetworkAccount: {
        id: 1,
        linked: true,
        invalidToken: true,
        provider: 'true'
      }
    }
  };
};

export const groups = (select: Array<Igroup>) => {
  const data = select.map(select => {
    const body = { id: select.id, name: select.name };
    return body;
  });
  return data;
};
